import { useMutation } from '@tanstack/react-query'
import { isPast } from 'date-fns'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { getCampaigns } from '@/api/campaigns/get-campaigns'
import { Card, CardContent } from '@/components/ui/card'
import { env } from '@/env'
import { useHeadManager } from '@/lib/headManagerProvider'

export function AwardedCampaigns() {
  const { setTitle } = useHeadManager()
  const navigate = useNavigate()

  const getAllCampaigns = useMutation({
    mutationFn: getCampaigns,
  })

  useEffect(() => {
    setTitle('Campanhas Premiadas')
    getAllCampaigns.mutate()
  }, [setTitle])

  const campanhasPremiadas = getAllCampaigns.data?.filter((campanha) =>
    isPast(new Date(campanha.campanha.dt_Sorteio)),
  )

  return (
    <div className="space-y-6 p-6">
      <h1 className="text-2xl font-bold">Campanhas Premiadas</h1>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
        {campanhasPremiadas?.map((campanha) => (
          <Card
            key={`premiada-${campanha.campanha.id}`}
            className="cursor-pointer rounded-2xl shadow-md"
            onClick={() =>
              navigate(`/campanha/${campanha.campanha.id}/resultado`)
            }
          >
            <img
              src={`${env.VITE_API_URL}${campanha.campanha.imagem}`}
              alt={campanha.campanha.titulo}
              className="h-32 w-full object-cover"
            />
            <CardContent className="space-y-1 p-3">
              <h3 className="text-base font-semibold">
                {campanha.campanha.titulo}
              </h3>
              <p className="text-muted-foreground text-sm">
                {campanha.campanha.descricao}
              </p>
              <span className="text-primary block font-bold">
                R$ {Number(campanha.campanha.titulo_Valor).toFixed(2)}
              </span>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  )
}
